import { get } from 'lodash';
import { useQuery, useQueryClient } from 'react-query';
import { getResiliencyData } from '@src/api/precision';

function useResiliency({ interval, filter }) {
  const queryClient = useQueryClient();

  const {
    data: resiliencyData,
    isLoading: isResiliencyDataLoading,
    status: resiliencyDataStatus,
  } = useQuery(
    ['resiliency-data', interval, filter],
    () =>
      getResiliencyData({
        interval,
        filter,
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
      select: (response) => get(response, ['data'], {}),
    },
  );

  const forceUpdateResiliencyData = () => {
    queryClient.invalidateQueries('resiliency-data');
  };

  return {
    resiliencyData,
    resiliencyDataStatus,
    forceUpdateResiliencyData,
    isResiliencyDataLoading,
  };
}

export default useResiliency;
